import {
  useMutation as reactQueryUseMutation,
  useQueryClient
} from '@tanstack/react-query';

import useAxios from './useAxios';

const isInTest = process.env.NODE_ENV === 'test';

const useMutation = ({ mutationFn, options = {} }) => {
  const {
    enabled: passedEnabled = true,
    baseUrl,
    token,
    clientId,
    browserUrl,
    ...useMutationOptions
  } = options;

  const axios = useAxios({ baseUrl, token, clientId, browserUrl });

  const mutationFunction = (...params) => {
    return mutationFn(axios, ...params);
  };

  const queryClient = useQueryClient();
  const mutation = reactQueryUseMutation({
    mutationFn: isInTest ? mutationFn : mutationFunction,
    ...useMutationOptions
  });

  const isGloballyDisabled = !queryClient.getDefaultOptions().mutations.enabled;

  const isEnabled = isGloballyDisabled ? false : passedEnabled;

  return {
    ...mutation,
    isEnabled,
    isDisabled: !isEnabled
  };
};

export default useMutation;
